import { useEffect, useState } from "react";
import i18n from "../../utils/translations/i18n";
import "./index.scss"
import { ReactComponent as PrefTick } from "../../assets/icons/preferancetick.svg"
const axios = require('axios');
declare const window: any;

const { t } = i18n;

const SuccessPage = (props: any) => {

    return (
        <div id="success-page" className={"successpage main-container"}>
            <div className="main-bdy">
                <div className="w-100 txt-center"><PrefTick /></div>
                <span className="w-100 txt-center head-txt">Your preferences have been updated successfully.</span>
                <hr className="hr-margin" />
                <span className="w-100 bdy-txt">
                    Thank you for updating your preferences. Your privacy is paramount to us, and we deeply value your trust in our commitment.
                </span>
                <span className="w-100 bdy-txt">
                    Please note that you can modify your preferences at anytime on this website or by calling toll free at 800-347-7367.
                </span>
            </div>
        </div>
    )
}

export default SuccessPage;
